import React from 'react';
import { useTranslation } from 'react-i18next';

const WAREHOUSE_COLORS = ['#3b82f6', '#a78bfa', '#10b981', '#f59e0b', '#f43f5e'];

const SalesByWarehouse = ({ data }) => {
    const { t } = useTranslation();
    if (!data?.warehouses?.length) return null;

    const strings = t('salesAnalytics.charts.warehouse', { returnObjects: true });
    const warehouses = data.warehouses;
    const maxOrders = Math.max(...warehouses.map(w => w.total_orders || 0));
    const maxWeight = Math.max(...warehouses.map(w => parseFloat(w.total_weight_tons) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.heading}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
                <span style={badgeStyle}>{strings.warehousesCount.replace('{count}', warehouses.length)}</span>
            </div>
            <div style={{ padding: '12px 20px 20px', display: 'flex', flexDirection: 'column', gap: 20 }}>
                {warehouses.map((wh, i) => {
                    const color = WAREHOUSE_COLORS[i % WAREHOUSE_COLORS.length];
                    const orderPct = maxOrders > 0 ? (wh.total_orders / maxOrders) * 100 : 0;
                    const weightPct = maxWeight > 0 ? (parseFloat(wh.total_weight_tons) / maxWeight) * 100 : 0;
                    return (
                        <div key={wh.warehouse_id} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: color }} />
                                    <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{wh.warehouse_name}</span>
                                </div>
                                <span style={{ fontSize: 11, color: '#9ca3af' }}>{strings.warehousePrefix.replace('{id}', wh.warehouse_id)}</span>
                            </div>
                            {/* Stats row */}
                            <div style={{ display: 'flex', gap: 16 }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span style={{ fontSize: 11, color: '#6b7280' }}>{strings.orders}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: color }}>{wh.total_orders}</span>
                                    </div>
                                    <div style={{ height: 5, borderRadius: 3, backgroundColor: '#e5e7eb' }}>
                                        <div style={{ height: '100%', borderRadius: 3, backgroundColor: color, width: `${orderPct}%`, transition: 'width 0.5s' }} />
                                    </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span style={{ fontSize: 11, color: '#6b7280' }}>{strings.weight}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: color }}>{parseFloat(wh.total_weight_tons || 0).toFixed(2)} {strings.tonSuffix}</span>
                                    </div>
                                    <div style={{ height: 5, borderRadius: 3, backgroundColor: '#e5e7eb' }}>
                                        <div style={{ height: '100%', borderRadius: 3, backgroundColor: color, width: `${weightPct}%`, transition: 'width 0.5s' }} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                {strings.qtyLabel} {Number(parseFloat(wh.total_quantity || 0).toFixed(0)).toLocaleString('en-IN')} {strings.unitsSuffix}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 14px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = { fontSize: 11, fontWeight: 700, color: '#0891b2', backgroundColor: '#ecfeff', borderRadius: 20, padding: '3px 10px' };

export default SalesByWarehouse;
